import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[ipSharedPasswordMatch]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordMatchValidator, multi: true }],
})
export class PasswordMatchValidator implements Validator {
  @Input('ipSharedPasswordMatch') originalValue!: string;

  validate(control: AbstractControl): { passwordMatch: true } | null {
    return this.originalValue === control.value ? null : { passwordMatch: true };
  }
}
